import * as types from './types';
import {
    getActivePlans,
    getInfo as getInfoService
} from '../../services/profile';
import { getBalance as getBalanceService } from '../../services/register';

export default {
    setUser({ commit, dispatch }, data) {
        commit(types.SET_USER, data);
        dispatch('getUserInfo', data.accountNo);
    },
    async getUserInfo({
        commit,
        state,
        dispatch
    }) {
        try {
            const { accountNo } = state;
            const result = await getActivePlans(accountNo);
            console.log('got plans result : ', result);
            const { response } = result;
            commit(types.SET_PROFILE, response);
            dispatch('getBalance');
            const infoResult = await getInfoService(accountNo);
            console.log('got user info : ', infoResult);
            const { response: { result: userInfo } } = infoResult;
            commit(types.SET_USER_INFO, userInfo);
        }
        catch(err) {
            console.log(err);
        }
    },
    async getMonthlyCost({ commit }, payload) {
        try {
          const result = await getActivePlans(payload);
          //console.log("kfdjhgfdj", result);
          let { response } = result;
          if (response["active-plans"].length == 0) {
            const resultEx = await getExpiredPlans(payload);
            response = resultEx.response;
          }
          commit(types.SET_PROFILE, response);
        } catch (err) {
          console.log(err);
        }
      },
    async getBalance({ commit, state }) {
        try {
            const { accountNo } = state;
            const result = await getBalanceService(accountNo);
            const { response: { walletBalance } } = result;
            commit(types.SET_BALANCE, walletBalance);
        }
        catch(err) {
            console.log(err);
        }
    }
}
